function About() {
  return (
    <section id="about" className="py-24 bg-apple-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl font-semibold text-apple-gray-900 tracking-tight mb-8">
            About EcoBag Pro
          </h2>
          <p className="text-lg text-apple-gray-600 leading-relaxed mb-6">
            We are a professional nonwoven bag manufacturer dedicated to providing premium custom packaging solutions 
            for brands worldwide. With advanced production technology and strict quality control, we deliver 
            eco-friendly bags that combine functionality with aesthetic appeal.
          </p>
          <p className="text-lg text-apple-gray-600 leading-relaxed">
            Our vision is to become the global leader in sustainable packaging, helping businesses reduce their 
            environmental footprint while maintaining the highest standards of quality and design innovation.
          </p>

          {/* Key Features */}
          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <div className="text-center">
              <div className="text-4xl font-bold text-apple-gray-900 mb-2">1+</div>
              <div className="text-sm text-apple-gray-600">Piece MOQ for Sampling</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-apple-gray-900 mb-2">100%</div>
              <div className="text-sm text-apple-gray-600">Quality Assurance</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-apple-gray-900 mb-2">Global</div>
              <div className="text-sm text-apple-gray-600">Shipping Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
